import UIAppBar from '@derolfgroep/ui-components/src/components/AppBar/AppBar'
import MainNavigationToggle from '@derolfgroep/ui-components/src/components/MainNavigation/MainNavigationToggle'
import AppLogo from '@derolfgroep/ui-components/src/components/AppLogo/AppLogo'
import AppBarToolBarItem from '@derolfgroep/ui-components/src/components/AppBar/AppBarToolBarItem'
import UserNavigation from '../UserNavigation/UserNavigation'
import { useMediaXsDown } from '@derolfgroep/ui-components/src/hooks/useMediaXsDown'
import { useNavigate } from 'react-router-dom'
import { ROUTE_SHORTCUTS } from '../../routes/constants'
import { useCallback, useEffect } from 'react'
import useCurrentUserIsStudentSelector from '../../api/selectors/userRoleSelectors/useCurrentUserIsStudentSelector'
import useInstitutionSelector from '../InstitutionSelector/useInstitutionSelector'
import InstitutionSelectorDesktop from '../InstitutionSelector/InstitutionSelectorDesktop'
import InstitutionSelectorMobile from '../InstitutionSelector/InstitutionSelectorMobile'
import useToggleLeftDrawer from '../AppLayout/useToggleLeftDrawer'
import { useMediaLgUp } from '@derolfgroep/ui-components/src/hooks/useMediaLgUp'
import useToggleRightDrawer from '../AppLayout/useToggleRightDrawer'
import TasksSidebarToggle from '../TasksSidebar/TasksSidebarToggle'
import useCurrentUserModulesSelector from '../../api/selectors/useCurrentUserModulesSelector'
import { MODULE_TASKS, MODULE_TASKS_V2 } from '../../../constants'
import useCheckSomeInArray from '../../hooks/utilities/useCheckSomeInArray'

const AppBar = () => {
  const isXsDown = useMediaXsDown()
  const isLargeUp = useMediaLgUp()
  const isStudent = useCurrentUserIsStudentSelector()
  const navigate = useNavigate()
  const { options, selectedInstitution, hasMultipleInstitutions, handleInstitutionSelection } = useInstitutionSelector()
  const handleClickLogo = useCallback(() => {
    navigate(ROUTE_SHORTCUTS)
  }, [navigate])
  const { isOpen: isLeftDrawerOpen, handleToggle: handleToggleLeftDrawer } = useToggleLeftDrawer()
  const { handleToggle: handleToggleRightDrawer } = useToggleRightDrawer()
  const { modules } = useCurrentUserModulesSelector()
  const userHasTaskModule = useCheckSomeInArray([MODULE_TASKS, MODULE_TASKS_V2], modules)

  useEffect(() => {
    if (isLargeUp && !isLeftDrawerOpen) {
      handleToggleLeftDrawer(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <UIAppBar>
      <AppBarToolBarItem>
        <MainNavigationToggle isOpen={isLeftDrawerOpen} onClickToggle={handleToggleLeftDrawer} />
        <AppLogo productName="ZuluConnect" onClick={handleClickLogo} showBeta={process.env.DEPLOYMENT_ENV === 'beta'} />
      </AppBarToolBarItem>
      {!isXsDown && !isStudent && hasMultipleInstitutions && (
        <AppBarToolBarItem>
          <InstitutionSelectorDesktop
            options={options}
            defaultValue={selectedInstitution}
            onSelectInstitution={handleInstitutionSelection}
          />
        </AppBarToolBarItem>
      )}
      <AppBarToolBarItem>
        {isXsDown && !isStudent && hasMultipleInstitutions && (
          <InstitutionSelectorMobile
            options={options}
            defaultValue={selectedInstitution}
            onSelectInstitution={handleInstitutionSelection}
          />
        )}
        {!isXsDown && userHasTaskModule && <TasksSidebarToggle onClickToggle={handleToggleRightDrawer} />}
        <UserNavigation />
      </AppBarToolBarItem>
    </UIAppBar>
  )
}

export default AppBar
